module.exports = __webpack_public_path__ + "components/modal-app-popup/static/caret-right-icon-e0721543d149719ae4f2b8695d641f31.svg";